// src/pages/Appli/AppliAdmin/ListingClients/components/AssociationsKpiGrid.jsx

import React from "react";

import {
  FaBell,
  FaBuilding,
  FaFlask,
  FaHandshake,
  FaStar,
  FaUsers,
} from "react-icons/fa";

const KPI_DEFINITIONS = [
  {
    key: "total",
    label: "Dossiers affichés",
    icon: FaBuilding,
    tone:
      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
  },
  {
    key: "prospects",
    label: "Prospects",
    icon: FaUsers,
    tone:
      "bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300",
  },
  {
    key: "tests",
    label: "En test",
    icon: FaFlask,
    tone:
      "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
  },
  {
    key: "clients",
    label: "Clients",
    icon: FaHandshake,
    tone:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  },
  {
    key: "remindersDue",
    label: "Relances à traiter",
    icon: FaBell,
    tone:
      "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
  },
  {
    key: "favorites",
    label: "Favoris",
    icon: FaStar,
    tone:
      "bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300",
  },
];

export default function AssociationsKpiGrid({
  kpis,
  loading = false,
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
        {KPI_DEFINITIONS.map(({ key }) => (
          <div
            key={key}
            className="h-28 animate-pulse rounded-2xl border border-slate-200 bg-slate-100 dark:border-slate-800 dark:bg-slate-800"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
      {KPI_DEFINITIONS.map(
        ({ key, label, icon: Icon, tone }) => {
          const value = kpis?.[key] || 0;

          return (
            <article
              key={key}
              className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:border-slate-800 dark:bg-slate-900"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-xs font-medium leading-5 text-slate-500 dark:text-slate-400">
                    {label}
                  </div>

                  <div className="mt-1 text-2xl font-bold tabular-nums text-slate-900 dark:text-white">
                    {value.toLocaleString("fr-FR")}
                  </div>
                </div>

                <div
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${tone}`}
                >
                  <Icon />
                </div>
              </div>

              {key === "remindersDue" && value > 0 ? (
                <div className="mt-2 text-[11px] font-medium text-red-600 dark:text-red-400">
                  Une action est nécessaire
                </div>
              ) : null}
            </article>
          );
        },
      )}
    </div>
  );
}